import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SsoEndpointsService } from 'src/app/services/sso-endpoints.service';

@Component({
  selector: 'app-sso-callback',
  templateUrl: './sso-callback.component.html',
  styleUrls: [ './sso-callback.component.scss' ],
})
export class SsoCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private ssoService: SsoEndpointsService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.authService.handleSSOCallback(params['code']);

        this.ssoService.removeSsoRequestingUser();
      } else {
        this.ssoService.removeSsoRequestingUser();
        console.warn('No SSO code found in URL.');
        this.router.navigate([ '/signin' ]); // Redirect if no code is present
      }
    });
  }
}
